import React from 'react'
import cn from 'classnames'
import './DecorativeCircles.scss'

type Props = {
  big?: boolean
}

const DecorativeCircles = ({ big = false }: Props) => (
  <span className={cn('c-circles hidden lg:block', big && 'c-circles--big')}>
    <span />
    <span />
    <span />
  </span>
)

export default DecorativeCircles
